import { EligibilityRule, EligibilityRuleType } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getEligibilityRules: (
  fetchContext: FetchContext,
  code: EligibilityRuleType,
  accessToken?: string,
) => Promise<EligibilityRule[]> = (fetchContext, code, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/eligibility-rules?code=${code}`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<EligibilityRule[]>(fetchContext.errorStore, response, 'get eligibility rules'));
